<div class="risk-action-proposes">

  @for (row of rows; track trackRow($index, row); let index = $index) {
    <div class="action-propose-row" [formGroup]="row">

      <div class="action-propose-header">
        <span class="action-propose-index">Action propose {{ index + 1 }}</span>
        @if (!readonlyRows) {
          <button
            type="button"
            class="btn btn-outline-danger btn-icon remove-row-button"
            title="Remove action propose"
            (click)="onRemoveRow(index)">
            <i class="fa fa-solid fa-trash"></i>
          </button>
        }
      </div>

      <div class="row">
        <div class="col-lg-4 col-md-6">
          <textarea-field
            label="Action Propose"
            placeholder="The mitigation action"
            [textareaFormControl]="getControl(row, 'actionPropose')"
            [readonly]="readonlyRows"
            [height]="120">
          </textarea-field>
        </div>

        <div class="col-lg-4 col-md-6">
          <textarea-field
            label="Comment"
            placeholder="Notes on the progress"
            [textareaFormControl]="getControl(row, 'comment')"
            [readonly]="readonlyRows"
            [height]="120">
          </textarea-field>
        </div>

        <div class="col-lg-4 col-md-12">
          <risk-action-propose-attachments
            [riskId]="riskId"
            [riskActionProposeId]="rowActionProposeId(row)"
            [attachments]="rowAttachments(row)"
            [readonlyAttachmentsPanel]="readonlyRows"
            (attachmentUploaded)="attachmentUploaded.emit()">
          </risk-action-propose-attachments>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="form-group">
            <label class="fw-bold risk-field-label">Responsible</label>
            <select-field
              [selectFormControl]="getControl(row, 'responsibleUserId')"
              [options]="responsibleOptions">
            </select-field>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <div class="form-group">
            <label class="fw-bold risk-field-label">Time Frame</label>
            <select-field
              [selectFormControl]="getControl(row, 'riskTimeFrameId')"
              [options]="timeFrameOptions">
            </select-field>
          </div>
        </div>

        <div class="col-lg-3 col-md-6">
          <input-field
            label="Last Evaluation"
            [inputFormControl]="getControl(row, 'lastEvaluation')"
            [type]="'datetime-local'"
            [readonly]="readonlyRows">
          </input-field>
        </div>

        <div class="col-lg-3 col-md-6">
          <input-field
            label="Next Review"
            [inputFormControl]="getControl(row, 'nextReview')"
            [type]="'datetime-local'"
            [readonly]="readonlyRows">
          </input-field>
        </div>
      </div>

    </div>
  } @empty {
    <div class="empty-text text-center text-muted py-3">
      @if (readonlyRows) {
        This risk has no action propose.
      } @else {
        No action propose yet. Use "Add item" to create the first one.
      }
    </div>
  }

  @if (!readonlyRows) {
    <div class="add-row-bar">
      <button type="button" class="btn btn-primary" (click)="onAddRow()">
        <i class="fa fa-plus me-1"></i>Add item
      </button>
    </div>
  }

</div>
